export default __webpack_public_path__ + "static/media/thumbs_down.ca9beedc.png";